import React from "react";
import { Box, Button, MenuItem, TextField, Typography } from "@mui/material";
import ReportPreview from "./ReportPreview";
import { getReportData } from "./ReportService";

type State = {
  reportcode: string;
  loading: boolean;
  error: string | null;
  reportData: any | null;
};

export default class ReportCenter extends React.Component<any, State> {
  state: State = {
    reportcode: "budget_planning",
    loading: false,
    error: null,
    reportData: null,
  };

  componentDidMount() {
    this.loadReport();
  }

  loadReport = async () => {
    this.setState({ loading: true, error: null });

    try {
      const params0 = {
        reportcode: this.state.reportcode,
        period: "2025",
        cycle: "FORM",
        scenario: "REVIS",
        costcenter: null,
        location: null,
        asofdate: "2025-06-30",
      };

      const params = {
        reportcode: this.state.reportcode,
        period: "2025",
        cycle: "FORM",
        scenario: "REVIS",
        costcenter: null,
        location: null,
        asofdate: "2025-06-30",
      };

      const res = await getReportData(params);

      console.log('reportrespose: ',res);

      this.setState({
        reportData: res.sd,
        loading: false,
      });
    } catch (err: any) {
      this.setState({
        loading: false,
        error: err?.message || "Unable to load report",
      });
    }
  };

  exportJson = () => {
    const { reportData, reportcode } = this.state;
    if (!reportData) return;

    const blob = new Blob([JSON.stringify(reportData, null, 2)], {
      type: "application/json",
    });

    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${reportcode}.json`;
    a.click();
    URL.revokeObjectURL(url);
  };

  render() {
    const { reportcode, reportData, loading, error } = this.state;

    return (
      <Box sx={{ p: 3, "@media print": {p: 0, bgcolor: "#fff",}}}>
        <Box className="report-controls" sx={{ display: "flex", gap: 2, alignItems: "center", mb: 3, "@media print": {display: "none"}}}>
          <TextField
            select
            size="small"
            label="Report"
            value={reportcode}
            onChange={(e) =>
              this.setState({ reportcode: e.target.value }, this.loadReport)
            }
            sx={{ minWidth: 280 }}
          >
            <MenuItem value="budget_planning">Budget Planning Report</MenuItem>
            <MenuItem value="budget_execution">Budget Execution Report</MenuItem>
            <MenuItem value="activity_based_budget">Activity-Based Budget Report</MenuItem>
            <MenuItem value="performance_kpi">Performance / KPI Report</MenuItem>
            <MenuItem value="management_dashboard">Management Dashboard Report</MenuItem>
          </TextField>

          <Button variant="contained" onClick={this.loadReport}>
            Generate
          </Button>

          <Button
            variant="outlined"
            onClick={() => window.print()}
          >
            Print / Save PDF
          </Button>

          <Button variant="outlined" onClick={this.exportJson}>
            Export JSON
          </Button>
        </Box>

        {loading && <Typography>Loading report...</Typography>}
        {error && <Typography color="error">{error}</Typography>}

        {reportData && <ReportPreview report={reportData} />}
      </Box>
    );
  }
}